<template>
  <table>
    <thead>
      <tr>
        <th>Part ID</th>
        <th>Contribution Rate</th>
        <th>YTD Annual Wages</th>
        <th>Annual Wages</th>
        <th>Actions</th>
      </tr>
    </thead>
    <tbody>
      <template v-for="participant in errors">
        <tr v-bind:key="participant.id">
          <td>{{ participant.id }}</td>
          <td>
            {{ participant.deferral_rate | numeral("0%") }}
            <roe-tooltip
              type="bottom"
              :text=tooltipText(participant)
            ></roe-tooltip>
          </td>
          <td>{{ participant.ytd_annual_wages | currency }}</td>
          <td>{{ participant.estimated_annual_wages | currency }}</td>
          <td>
            <div class="btn-wrap">
              <button
                class="btn-secondary"
                @click="fixParticipantForm.initForm(participant)"
              >
                Fix
              </button>
            </div>
            <div class="btn-wrap">
              <button
                class="btn-secondary"
                @click="updateParticipant(participant)"
              >
                Process
              </button>
            </div>
            <div class="btn-wrap">
              <button
                class="btn-alert"
                @click="destroyParticipant(participant.id)"
              >
                Delete
              </button>
            </div>
          </td>
        </tr>
      </template>
    </tbody>
  </table>
</template>

<script>
import { DESTROY_PARTICIPANT, UPDATE_PARTICIPANT } from "@/store/actions.type";
import RoeTooltip from "@/components/_shared/Tooltip";

export default {
  name: "RoeDeferralRateErrorList",
  components: { RoeTooltip },
  props: {
    errors: {
      type: Array
    },
    fixParticipantForm: {}
  },
  methods: {
    destroyParticipant(id) {
      this.$store.dispatch(DESTROY_PARTICIPANT, {
        id: id,
        reportId: this.$router.currentRoute.params.id
      });
    },
    tooltipText(participant) {
      return `Pre-Tax YTD Deferrals: $${participant.pre_tax_deferral_ytd_dollars}<br>
             Pre-Tax Catchup YTD Deferrals: $${participant.pre_tax_deferral_ytd_catchup_dollars}<br>
             Roth YTD Deferrals: $${participant.roth_deferral_ytd_dollars}<br>
             Roth Catchup YTD Deferrals: $${participant.roth_deferral_ytd_catchup_dollars}<br>
             Post-Tax YTD Contributions: $${participant.post_tax_deferral_ytd_dollars}`;
    },
    updateParticipant(participant) {
      this.$store.dispatch(UPDATE_PARTICIPANT, {
        reportId: this.$router.currentRoute.params.id,
        params: {
          id: participant.id,
          estimated_annual_wages: participant.estimated_annual_wages
        }
      });
    }
  }
};
</script>
